import { AutoComplete, Input } from 'antd';
import { useQueryParamsAsKeyValuePair } from 'hooks/useQueryParams';
import { debounce } from 'lodash';
import React, { useMemo } from 'react';
import { useHistory } from 'react-router';
import { getNewQueryString } from 'utils';

import { SearchContainerStyled } from './styled';
import { ISearchBarProps } from './types';

const SearchBar: React.FC<ISearchBarProps> = ({ placeholder, onSearch, onChange, name, options }) => {
  const history = useHistory();
  const { location } = history;
  const queryObject = useQueryParamsAsKeyValuePair();

  const onSearchStart = (v: any) => {
    if (onSearch) onSearch(v);
    else {
      const newQuery = name ? getNewQueryString(history.location.search, { [name]: v, page: undefined }) : '';
      history.push({
        pathname: location.pathname,
        search: newQuery,
      });
    }
  };

  const onInputChange = useMemo(
    () =>
      debounce((v: any) => {
        if (onChange) onChange(v);
      }, 150),
    [],
  );

  const defaultValue = name ? queryObject?.[name] : undefined;
  return (
    <SearchContainerStyled>
      <AutoComplete defaultValue={defaultValue} onSelect={onSearchStart} onSearch={onInputChange} options={options}>
        <Input.Search
          size='large'
          placeholder={placeholder || 'Search...'}
          onSearch={onSearchStart}
          defaultValue={defaultValue}
        />
      </AutoComplete>
    </SearchContainerStyled>
  );
};

export default React.memo(SearchBar);
